import React from "react";
import { Modal, Button } from "antd";

interface DeleteInsightModalProps {
  insight: { id: string; alert?: { id: string } };
  isOpen: boolean;
  onClose: () => void;
  confirmLoading: boolean;
  handleOK: (
    insight: { id: string; alert?: { id: string } },
    id: string,
    type?: string,
  ) => void;
  mode?: "insight" | "alert";
}

export default function DeleteInsightModal({
  insight,
  isOpen,
  onClose,
  confirmLoading,
  handleOK,
  mode = "insight",
}: DeleteInsightModalProps) {
  const title = mode === "insight" ? "Delete insight?" : "Delete alert?";
  const description =
    mode === "insight"
      ? "Are you sure you want to delete this insight and its history? You won't be able to recover them."
      : "Are you sure you want to delete this alert? You won't be able to recover it.";

  const note =
    mode === "insight"
      ? "You can archive an insight instead."
      : "Deleting the alert will not affect the insight data.";

  const handleDelete = (insight: { id: string; alert?: { id: string } }) => {
    if (mode === "insight") {
      handleOK(insight, insight.id);
    } else {
      handleOK(insight, insight.alert!.id, "alert");
    }
  };

  return (
    <div>
      <Modal
        centered
        width={422}
        open={isOpen}
        confirmLoading={confirmLoading}
        onCancel={onClose}
        footer={
          <div className="flex items-center justify-between mt-7">
            <Button
              type="default"
              className="text-[#2B4752] border border-[#2B4752] rounded-sm"
              onClick={onClose}
            >
              Cancel
            </Button>
            <Button
              type="primary"
              className="bg-[#980000] active:bg-[#980000]! hover:bg-[#980000]! border-0 rounded-sm"
              onClick={() => handleDelete(insight)}
              loading={confirmLoading}
            >
              Delete
            </Button>
          </div>
        }
      >
        <p className="text-lg font-bold mb-3">{title}</p>
        <p className="text-[#2B4752] text-base">{description}</p>
        <p className="text-[#00000073] text-sm">
          {" "}
          <span className="font-semibold">*Note:</span> {note}
        </p>
      </Modal>
    </div>
  );
}
